const trackingDomains = {
  'search.yahoo.com': '6-yahooNatural',
  'www.google.com': '7-googleNatural',
  'google.com': '7-googleNatural',
  'search.msn.com': '8-MSNnatural',
  'search.live.com': '8-MSNnatural',
  'search.comcast.net': '9-CNETnatural',
  'www.ask.com': '10-askNatural',
  'ask.com': '10-askNatural',
  'search.ask.com': '10-askNatural',
  'aolsearch.aol.com': '11-AOLnatural',
  'search.aol.com': '11-AOLnatural'
}

const trackingIds = {
  '1': '1-direct',
  '2': '2-yahoopaid',
  '3': '3-googlepaid',
  '4': '4-msnpaid',
  '5': '5-yahooinclusion',
  '13': '13-googlepaid_contentmatch',
  '14': '14-yahoopaid_contentmatch',
  '15': '15-yahoopaid_local',
  '16': '16-yahoopaid_premiumcatauto',
  '17': '17-yahoopaid_frontpagebt',
  '18': '18-yahoopaid_searchsubmit',
  '19': '19-googlepaid_generalcars',
  '20': '20-googlepaid_trademark',
  '21': '21-googlepaid_categories',
  '22': '22-googlepaid_make',
  '23': '23-googlepaid_model',
  '24': '24-googlepaid_quote',
  '25': '25-googlepaid_geotargetquote',
  '26': '26-googlepaid_competitors',
  '27': '27-google_ppa_ncquote',
  '28': '28-yahoopaid_generalcars',
  '29': '29-yahoopaid_trademark',
  '30': '30-yahoopaid_categories',
  '31': '31-yahoopaid_make',
  '32': '32-yahoopaid_model',
  '33': '33-yahoopaid_quote',
  '34': '34-yahoopaid_competitors',
  '35': '35-askpaid',
  '36': '36-rss',
  '37': '37-emailpage',
  '38': '38-quigo_paid_inclusion_yahoo',
  '39': '39-search_syndication',
  '40': '40-referred',
  '100': '100-deal-reynolds',
  '101': '101-deal-bzresults',
  '1000': '1000-askroc'
}

const getReferrerTrackingId = (location, referrerUrl) => {
  const trackingIdCookieName = 'trid'
  const defaultTrackingId = '1'
  const referralTrackingId = '40'
  let trackingValue = ''

  // look for the tracking value in the trid QS parameter
  if (location.search) {
    const qs = location.initQueryParams

    if (qs[trackingIdCookieName] && qs[trackingIdCookieName].length > 0) {
      const trackingId = qs[trackingIdCookieName]
      const trackingIdNum = Number(trackingId)

      if (!isNaN(trackingIdNum)) {
        // check if trid is a number
        if (trackingIdNum > 1000) {
          // trid values above 1,000 are pass through values which will not be looked up
          trackingValue = trackingId
        } else {
          // if less than 1000, look up corresponding tracking value for the id from
          // the referrer tracking id mapping table
          if (trackingIds[trackingIdNum]) {
            trackingValue = trackingIds[trackingIdNum]
          }
        }
      }
    }
  }

  // if no tracking id passed in url, or value not found in config engine,
  // check based on referrer (if available, and not = kbb.com)
  if (trackingValue === '' && (referrerUrl || referrerUrl !== '')) {
    const domain = new URL(referrerUrl).hostname

    // ignore kbb.com domain
    if (domain.indexOf('kbb.com') === -1) {
      if (trackingDomains[domain]) {
        // look up the cooresponsing tracking value for the domain from the referrer domain mapping table
        trackingValue = trackingDomains[domain]
      } else {
        // if no value for referring host, then set the tracking value to the referral tracking id mapping
        trackingValue = trackingIds[referralTrackingId]
      }
    }
  }

  // if trackingValue is still not found, then use default tracking id for a direct link
  if (trackingValue === '' || trackingValue === null) {
    trackingValue = trackingIds[defaultTrackingId]
  }

  return trackingValue
}

export { getReferrerTrackingId }
